import { render, staticRenderFns } from "./EmptyWallet.vue?vue&type=template&id=0e163c69"
import script from "./EmptyWallet.vue?vue&type=script&lang=js"
export * from "./EmptyWallet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports